module.exports = __webpack_public_path__ + "static/media/049-forward.f7ec0a78.svg";